import { gql } from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as React from 'react';

import { Speakers_EventFragment } from './graphql-types/Speakers_EventFragment';

import { SpeakerUser } from './SpeakerUser';

export const Speakers: React.FC<{
  event: Speakers_EventFragment;
  isHtml: boolean;
}> & {
  eventFragment: DocumentNode;
} = (props) => {
  if (!props.event) {
    return null;
  }

  const speakers =
    props.event.__typename === 'ConferenceEventV2'
      ? props.event.speakersWithSessions
          .filter((speakerWithSessions) => !speakerWithSessions.isHidden)
          .map((speakerWithSessions) => speakerWithSessions.speaker)
      : props.event.speakers
          ?.filter((speaker) => !speaker.isHidden)
          .map((speaker) => speaker.user) || [];

  if (!speakers.length) return null;

  return props.isHtml ? (
    <>
      <h2>Speakers:</h2>
      <ul>
        {speakers.map((speaker) => (
          <SpeakerUser key={speaker._id} user={speaker} isHtml={props.isHtml} />
        ))}
      </ul>
    </>
  ) : (
    <>
      Speakers: <br />
      {speakers.map((speaker) => (
        <SpeakerUser key={speaker._id} user={speaker} isHtml={props.isHtml} />
      ))}
    </>
  );
};

Speakers.eventFragment = gql`
  fragment Speakers_EventFragment on EventV2 {
    _id
    ... on SimpleEventV2 {
      _id
      speakers {
        user {
          _id
          ...SpeakerUser_userFragment
        }
        isHidden
      }
    }
    ... on ConferenceEventV2 {
      _id
      speakersWithSessions {
        speaker {
          _id
          ...SpeakerUser_userFragment
        }
        isHidden
      }
    }
  }
  ${SpeakerUser.userFragment}
`;
